/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentContentDto } from '../../models/document-content-dto';

export interface GetDocumentContentById$Params {
  idDocument: string;
}

export function getDocumentContentById(
  http: HttpClient,
  rootUrl: string,
  params: GetDocumentContentById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<DocumentContentDto>> {
  const rb = new RequestBuilder(rootUrl, getDocumentContentById.PATH, 'get');
  if (params) {
    rb.path('idDocument', params.idDocument, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentContentDto>;
    })
  );
}

getDocumentContentById.PATH = '/v2/documents/{idDocument}/contenu';
